<template>
	<div class="container pt-6 pb-10">
		<div class="flex flex-col items-start sm:flex-row sm:justify-between sm:items-center gap-2 py-2 mb-4">
			<h1 class="page-title">Oferte</h1>
			<v-btn :to="'/oferte/add/' + false" color="teal" class="uppercase" dark>
				Adauga oferta
			</v-btn>
		</div>
		<div class="light-grey rounded mb-4 p-4">
			<div class="flex flex-col lg:flex-row lg:justify-between lg:items-center gap-2 lg:gap-10 w-full">
				<div class="w-full lg:w-1/2 flex flex-row items-center gap-2">
					<!-- <v-text-field v-model="filterInput" clearable flat solo hide-details
						prepend-inner-icon="mdi-magnify" label="Cauta oferta dupa client"></v-text-field> -->
					<v-text-field v-model="searchClient" clearable flat solo hide-details @keydown.enter="searchOffers"
						@click:clear="resetInitialOffers" prepend-inner-icon="mdi-magnify"
						label="Cauta oferta dupa client">
					</v-text-field>
					<v-btn color="blue-grey" class="uppercase" large dark @click="searchOffers">Cauta</v-btn>
				</div>
				<div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 w-full lg:w-auto">
					<v-select ref="selectAgent" v-model="filterAgent" class="w-full sm:w-60" :items="agents"
						item-text="username" item-value="id_user"
						:clearable="['admin', 'superuser', 'user'].includes(user.rol)"
						@click:clear="$refs.selectAgent.blur()" label="Intocmit de" solo hide-details></v-select>
					<div class="w-full sm:w-60">
						<v-menu v-model="monthpickerMenu" class="w-full" :close-on-content-click="false" left
							transition="scale-transition" offset-y min-width="auto">
							<template v-slot:activator="{ on, attrs }">
								<v-text-field v-model="monthText" class="date-field"
									:class="{ 'opacity-60': isOffersSearchList }" label="Luna" solo
									prepend-inner-icon="mdi-calendar" hide-details readonly v-bind="attrs"
									v-on="on"></v-text-field>
							</template>
							<v-date-picker v-model="selectedMonth" no-title type="month"
								@input="changeMonth"></v-date-picker>
						</v-menu>
					</div>
				</div>
			</div>
		</div>
		<v-data-table :headers="headers" :items="filterBy(oferte, filterInput, selectedUser)" :loading="loadingOferte"
			:items-per-page="-1" hide-default-footer>
			<template v-if="isOffersSearchList" v-slot:top>
				<div class="text-lg text-primary font-medium p-4 border-b border-primary">Rezultate cautare</div>
			</template>
			<template v-slot:item.status="{ item }">
				<OfertaStatus :item="item" @changeStatus="changeStatus" />
			</template>
			<template v-slot:item.data="{ item }">
				{{ item.data | formatDate }}
			</template>
			<template v-slot:item.suma="{ item }">
				{{ item.suma }} {{ item.moneda }}
			</template>
			<template v-slot:item.actions="{ item }">
				<v-btn text rounded color="primary" :to="'/oferte/single/' + item.id">detalii</v-btn>
			</template>
		</v-data-table>

		<v-dialog v-model="visibleStatusModal" max-width="600px">
			<OfertaStatusCard :changedStatusItem="changedStatusItem" :sentAnalysis="sentAnalysis"
				@requestAnalysis="visibleAnalysisDialog = true" @close="closeModal" />
		</v-dialog>

		<v-dialog v-model="visibleAnalysisDialog" max-width="700px">
			<v-card>
				<v-form ref="analysisForm" v-model="validAnalysisForm" @submit.prevent="sendAnalysisReq">
					<v-card-title>
						<span class="text-h5">Solicită analiza clientului</span>
					</v-card-title>
					<v-card-text v-if="changedStatusItem.client">
						<div>
							<h3 class="mb-4"><span class="font-normal">Client: </span>{{ changedStatusItem.client.name
							}} {{ changedStatusItem.client.cui ? '(' + changedStatusItem.client.cui + ')' : '' }}
							</h3>
							<p>Completeză următoarele informații despre client</p>
						</div>
						<div class="grid grid-cols-1 sm:grid-cols-2 gap-x-4">
							<v-select label="Cifră afaceri an precendent" outlined v-model="analysisLead.turnover"
								:items="turnoverOptions" item-text="text" item-value="value" suffix="RON"
								:rules="[rules.required]"></v-select>
							<v-select label="Profit net an precedent" outlined v-model="analysisLead.netProfit"
								:items="profitOptions" item-text="text" item-value="value" suffix="RON"
								:rules="[rules.required]"></v-select>
							<v-select label="Domeniu de activitate" outlined v-model="analysisLead.activityField"
								:items="activityFields" item-text="text" item-value="value"
								:rules="[rules.required]"></v-select>
							<v-select label="Nr. angajati" outlined v-model="analysisLead.employees"
								:items="employeeOptions" item-text="text" item-value="value" suffix="angajati"
								:rules="[rules.required]"></v-select>
						</div>
					</v-card-text>
					<div class="flex flex-row justify-end gap-2 mt-4 p-4">
						<v-btn color="blue-grey" class="uppercase" dark large
							@click="closeAnalysisModal">Anuleaza</v-btn>
						<v-btn color="teal" dark class="uppercase" large type="submit">Trimite</v-btn>
					</div>
				</v-form>
			</v-card>
		</v-dialog>

		<!-- <pre>{{ oferte }}</pre> -->
		<!-- <pre>Loaded: {{userLoaded}}</pre> -->
		<!-- <pre>{{$store.state}}</pre> -->
		<!-- <pre>{{$data}}</pre> -->
		<!-- <pre>{{ selectedUser }}</pre> -->
		<!-- <pre>{{ user }}</pre> -->
	</div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import firebase from "firebase/app";
import { DateTime } from 'luxon';
import OfertaStatus from "./OfertaStatus.vue";
import OfertaStatusCard from "./OfertaStatusCard.vue";

export default {
	name: "Oferte",
	components: {
		OfertaStatus,
		OfertaStatusCard
	},
	data() {
		return {
			user_email: firebase.auth().currentUser.email,
			validAnalysisForm: false,
			// contactDatepickerMenu: false,
			filterInput: "",
			searchClient: null,
			monthpickerMenu: false,
			selectedMonth: new Date().toISOString().substring(0, 7),
			selectedUser: null,
			visibleStatusModal: false,
			visibleAnalysisDialog: false,
			headers: [
				{
					text: 'Nr.',
					align: 'start',
					sortable: false,
					value: 'id',
					width: '5%'
				},
				{
					text: 'Data',
					align: 'start',
					sortable: false,
					value: 'data',
					width: '5%'
				},
				{
					text: 'Status',
					align: 'center',
					sortable: false,
					value: 'status',
					width: '10%'
				},
				{
					text: 'Client',
					align: 'start',
					sortable: false,
					value: 'nume',
					width: '35%'
				},
				{
					text: 'Valoare',
					align: 'start',
					sortable: false,
					value: 'suma',
					width: '10%'
				},
				{
					text: 'Intocmit de',
					align: 'start',
					sortable: false,
					value: 'username',
					width: '10%'
				},
				{
					value: 'actions',
					sortable: false,
					width: '5%'
				}
			],
			changedStatusItem: {},
			sentAnalysis: false,
			analysisLead: {},
			rules: {
				required: value => !!value || 'Câmp obligatoriu'
			}
		};
	},
	computed: {
		...mapState('salesLeads', ['turnoverOptions', 'profitOptions', 'activityFields', 'employeeOptions']),
		monthText() {
			return this.$options.filters.formatMonth(this.selectedMonth)
		},
		firstDay() {
			return new Date(this.selectedMonth).toISOString().split('T')[0]
		},
		lastDay() {
			return new Date(new Date(this.selectedMonth).getFullYear(), new Date(this.selectedMonth).getMonth() + 1, 1).toISOString().split('T')[0]
		},
		oferte() {
			return this.$store.getters.oferte;
		},
		loadMoreOferteID() {
			if (this.oferte.length > 0) {
				return this.oferte.slice(-1)[0].id;
			} else {
				return 100000;
			}
		},
		user() {
			return this.$store.getters.loggedUser;
		},
		userLoaded() {
			return this.$store.getters.userLoaded;
		},
		loadingOferte() {
			return this.$store.getters.loadingOferte;
		},
		isOffersSearchList() {
			return this.$store.getters.isOffersSearchList
		},
		filterAgent: {
			get: function () {
				return this.selectedUser
			},
			// setter
			set: function (newValue) {
				this.selectedUser = newValue
			},
		},
		agents() {
			let array = [];
			let user = {};

			this.oferte.forEach((oferta) => {
				user = {
					id_user: oferta.id_user,
					username: oferta.username,
				};
				if (this.containsObject(user, array)) {
					return;
				} else {
					array.push(user);
				}
			});
			return array.filter(this.onlyUnique);
		}
	},
	watch: {},
	methods: {
		...mapActions('salesOffers', ['sendAnalysisRequest']),
		escapeRegExp(s) {
			return s.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
		},
		filterBy(list, value, agent) {
			if (!value) {
				value = ""
			}
			const words = value
				.split(/\s+/g)
				.map((s) => s.trim())
				.filter((s) => !!s);

			const hasTrailingSpace = value.endsWith(" ");

			const searchRegex = new RegExp(
				words
					.map((word, i) => {
						if (i + 1 === words.length && !hasTrailingSpace) {
							// The last word - ok with the word being "startswith"-like
							return `(?=.*\\b${this.escapeRegExp(word)})`;
						} else {
							// Not the last word - expect the whole word exactly
							return `(?=.*\\b${this.escapeRegExp(word)}\\b)`;
						}
					})
					.join("") + ".+",
				"i"
			);

			// See if current user has oferte
			let userOferte = this.agents.find((item) => {
				return item.id_user == agent;
			});
			// filter different cases
			return list.filter((oferta) => {
				if (userOferte == undefined) {
					return searchRegex.test(oferta.nume);
				} else {
					return (
						searchRegex.test(oferta.nume) &&
						oferta.id_user == agent
					);
				}
			});
		},
		fetchUser() {
			let mail = this.user_email;
			this.$store.dispatch("fetchUser", mail);
		},
		fetchOferte() {
			this.$store.dispatch("fetchOferte", { fromDate: this.firstDay, toDate: this.lastDay });
			this.searchClient = null
		},
		onlyUnique(value, index, arr) {
			return arr.indexOf(value) === index;
		},
		containsObject(obj, list) {
			var i;
			for (i = 0; i < list.length; i++) {
				if (list[i].id_user === obj.id_user) {
					return true;
				}
			}
			return false;
		},
		changeStatus(item) {
			this.changedStatusItem = Object.assign({}, { id: item.id, client: { name: item.nume, cui: item.cui }, status_oferta: item.status_oferta, contactDate: item.contact_date || DateTime.now().toFormat('yyyy-LL-dd'), contactType: item.contact_type, pending_reason: item.pending_reason, reject_reason: item.reject_reason })
			this.visibleStatusModal = true
		},
		closeModal() {
			this.visibleStatusModal = false
			this.$nextTick(() => {
				this.changedStatusItem = Object.assign({}, {})
				this.sentAnalysis = false
				this.analysisLead = Object.assign({}, {})
			})
		},
		closeAnalysisModal() {
			this.visibleAnalysisDialog = false
			this.$nextTick(() => {
				this.analysisLead = Object.assign({}, {})
			})
		},
		async sendAnalysisReq() {
			const valid = await this.$refs.analysisForm.validate();

			if (valid) {
				this.sendAnalysisRequest({ leadData: this.analysisLead, client: this.changedStatusItem.client, user: { name: this.user.username, email: this.user.email_user } });
				this.sentAnalysis = true
				this.visibleAnalysisDialog = false
			}
		},
		async changeOfertaStatus() {
			const valid = await this.$refs.statusForm.validate();

			if (valid) {
				this.$store.dispatch("updOfertaStatus", this.changedStatusItem);
				this.closeModal()
			}
		},
		changeMonth() {
			this.monthpickerMenu = false
			this.fetchOferte()
		},
		// fetchReports() {
		// 	this.$store.dispatch("fetchWPOrderReports", { fromDate: this.dateRange[0], toDate: this.dateRange[1] });
		// 	this.dateRange = this.newDateRange
		// }
		resetInitialOffers() {
			this.fetchOferte();
		},
		searchOffers() {
			this.$store.dispatch("fetchOffersBySearchTerm", this.searchClient)
		}
	},
	created: function () {
		this.fetchOferte();
	},
	mounted: function () {
		if (this.user.rol == 'admin') {
			this.selectedUser = null
		} else {
			this.selectedUser = this.user.id_user
		}

	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
::v-deep .v-data-table__mobile-table-row {
	display: block !important;
	margin-bottom: 12px;
}
</style>
